"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IFrame = exports.VideoWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactLiteYoutubeEmbed = _interopRequireDefault(require("react-lite-youtube-embed"));
require("react-lite-youtube-embed/dist/LiteYouTubeEmbed.css");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var VideoWrapper = _styledComponents.default.div.withConfig({
  displayName: "style__VideoWrapper",
  componentId: "vwdc2b-0"
})(["display:block;position:relative;"]);
exports.VideoWrapper = VideoWrapper;
var IFrame = (0, _styledComponents.default)(_reactLiteYoutubeEmbed.default).withConfig({
  displayName: "style__IFrame",
  componentId: "vwdc2b-1"
})(["position:absolute;top:0;left:0;width:100%;height:100%;"]);
exports.IFrame = IFrame;